import { NameStyled } from "../Style-components/Name.Styled";
function Name() {
  return (
    <NameStyled className="ab-br">
      <h1> &lt;Reetu Raj&gt;</h1>
      <h2 className="light">//fullstack developer</h2>
    </NameStyled>
  );
}

export default Name;
